import {
    ROOT,
    CHANNEX_GET_ALL,
    CHANNEX_GET_STATUS,
    CHANNEX_GET_IFRAME,
    CHANNEX_OTA_GET_DETAIL,
    CHANNEX_OTA_UPDATE_DETAIL,
    PRICELAB_GET_ALL,
    PRICELAB_GET_STATUS,
    PRICELAB_SYNC,
    SYNCOTA_UPDATE_EXTRA_CHANNEX
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";
import { PRICELAB_OTA_GET_DETAIL, PRICELAB_OTA_UPDATE_DETAIL } from "../../_helpers/constant";

function getAllChannexOTA(data) {
    return fetch(ROOT + CHANNEX_GET_ALL, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getStatusChannexOTA(data) {
    return fetch(ROOT + CHANNEX_GET_STATUS, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getAllPriceLabOTA(data) {
    return fetch(ROOT + PRICELAB_GET_ALL, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getStatusPriceLabOTA(data) {
    return fetch(ROOT + PRICELAB_GET_STATUS, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getIframe(data) {
    return fetch(ROOT + CHANNEX_GET_IFRAME, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function detailSyncOTA(id) {
    return fetch(ROOT + CHANNEX_OTA_GET_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function detailPricelabSyncOTA(id) {
    return fetch(ROOT + PRICELAB_OTA_GET_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateDetailChannexOTA(data, id) {
    return fetch(ROOT + CHANNEX_OTA_UPDATE_DETAIL + `/${id}`, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateDetailPricelabOTA(data, id) {
    return fetch(ROOT + PRICELAB_OTA_UPDATE_DETAIL + `/${id}`, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function syncPricelabs(id) {
    return fetch(ROOT + PRICELAB_SYNC + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateExtraChannex(data) {
  return fetch(ROOT + SYNCOTA_UPDATE_EXTRA_CHANNEX, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion
export const velaOta = {
    updateDetailPricelabOTA,
    detailPricelabSyncOTA,
    getAllPriceLabOTA,
    getStatusPriceLabOTA,
    getAllChannexOTA,
    getStatusChannexOTA,
    getIframe,
    detailSyncOTA,
    updateDetailChannexOTA,
    syncPricelabs,
    updateExtraChannex
}